import React from "react";

interface Props {}

const Payment = (props: Props) => {
  return <div></div>;
};

export default Payment;
